import ReactGA from "react-ga";
import { AdSettings } from "../../types/ads";
import settings from "../../settings";

export const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-w-[100vw] h-full min-h-[200px]">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-800"></div>
  </div>
);

export const IntroScreen = ({
  showMainContent,
  setShowMainContent,
  isLogoLoading,
  adSettings,
  setShowTermsModal,
  intl,
}: {
  showMainContent: boolean;
  setShowMainContent: React.Dispatch<React.SetStateAction<boolean>>;
  isLogoLoading: boolean;
  adSettings: AdSettings | null;
  setShowTermsModal: React.Dispatch<React.SetStateAction<boolean>>;
  intl: any;
}) => (
  <div
    className={`flex items-center justify-center min-h-[calc(100vh-200px)] xl:min-h-[calc(100vh-200px)] transition-all duration-500 ease-in-out ${
      showMainContent
        ? "opacity-0 -translate-y-10 pointer-events-none"
        : "opacity-100 translate-y-0"
    }`}
  >
    <div className="p-6 bg-white rounded-lg shadow-lg text-center max-w-sm w-full">
      <h2 className="mb-4 font-bold text-lg text-gray-800">
        {intl.formatMessage({ id: "adRenderer.sponsoredBy" })}
      </h2>
      {isLogoLoading ? (
        <LoadingSpinner />
      ) : (
        <img
          src={settings.logoPartner}
          alt="Logo"
          className="w-[200px] h-[200px] mx-auto rounded-md object-contain"
        />
      )}
      <button
        onClick={() => {
          setShowMainContent(true);
          const pageHeader = document.getElementById("header");
          if (pageHeader && adSettings?.ad_type !== undefined)
            pageHeader.style.display = "none";
          ReactGA.event({
            category: "Button",
            action: "Click Continue",
            label: "Intro Screen",
          });
        }}
        className="mt-6 px-6 py-3 rounded-md w-full font-bold text-white transition duration-300 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ backgroundColor: adSettings?.button_color || "#007bff" }}
      >
        {intl.formatMessage({ id: "adRenderer.continueToConnect" })}
      </button>
      <p className="mt-4 font-bold text-gray-600">
        {intl.formatMessage({ id: "adRenderer.agree" })}
        <button
          onClick={() => setShowTermsModal(true)}
          className="text-blue-500 underline hover:text-blue-700"
        >
          {intl.formatMessage({ id: "adRenderer.termsOfUse" })}
        </button>
      </p>
    </div>
  </div>
);
